module.exports = __webpack_public_path__ + "static/media/singlesample.6f34a578.pdf";